import BaseService from "./geral/BaseService";

const base = "AssociacaoDepotBooking";

export default class BookingDepotService extends BaseService{
    
    constructor(props){
        super(props)
    }

    ListarArmador = () => {
        return super.httpGet(`/${base}/ListarArmador`);
    }

    ListarOperacoes = () => {
        return super.httpGet(`/${base}/ListarOperacoes`);
    }

    ListarDepot = () => {
        return super.httpGet(`/${base}/ListarDepot`);
    }

    ListarBooking = (oper) => {
        return super.httpGet(`/${base}/ListarBooking?oper=${oper}`);
    }
    
    ListarArmadorDepotDefault = () => {
        return super.httpGet(`/${base}/ListarArmadorDepotDefault`);
    }

    SalvarDepotDefaultArmador = (listaDefault) => {
        return super.httpPost(`/${base}/SalvarDepotDefaultArmador`, listaDefault);
    }

    VerificarQtdAssocDessoc = (booking, bookingGkey, RbdQtdCntr, indOperacao, depotId) => {
        return super.httpGet(`/${base}/VerificarQtadeAssocDesassoc?booking=${booking}&bookingGkey=${bookingGkey}&RbdQtdCntr=${RbdQtdCntr}&indOperacao=${indOperacao}&depotId=${depotId}`);
    }
    
    RecuperarDepotDefaultPorArmador = (armadorId) => {
        return super.httpGet(`/${base}/RecuperarDepotDefaultPorArmador?armadorId=${armadorId}`);
    }
    
    VerificarListaNegraDepot = (depotId) => {
        return super.httpGet(`/${base}/VerificarListaNegraDepot?depotId=${depotId}`);
    }
    
    AssociarBooking = (tipoCntr, codViagem, nomeNavio, qtdAssociar, depotId, line, booking, bookingGkey, EarliestDate, LatestDate) => {
        return super.httpGet(`/${base}/AssociarBooking?TipoCntr=${tipoCntr}&codViagem=${codViagem}&nomeNavio=${nomeNavio}&qtdAssociar=${qtdAssociar}&depotId=${depotId}&line=${line}&booking=${booking}&bookingGkey=${bookingGkey}&EarliestDate=${EarliestDate}&LatestDate=${LatestDate}`);
    }
    
    DesassociarBooking = (AssociacaoId, qtdDesassociar) => {
        return super.httpGet(`/${base}/DesassociarBooking?AssociacaoId=${AssociacaoId}&qtdDesassociar=${qtdDesassociar}`);
    }

}


// WEBPACK FOOTER //
// ./src/services/BookingDepotService.js